export function ready(){
    const loader = document.querySelector(".l-loader");

    const setReadyClass = () => {
        loader && loader.classList.remove("-active");

        document.body.classList.add("-ready");
        setTimeout(() => {
            document.body.classList.add("-readyend");
        }, 2000);
    };

    setReadyClass();
}
